import { create } from 'zustand'
import { type zonaType } from './types'

interface zonasState {

    zonas: zonaType[],
    numZona: number,
    configSentFlag: boolean,    //Flag que indica si la configuración ya se envió
    configId: number,           //Es el Id de la configuración en la base de datos, una vez enviada
    configResp: number,         //Es la respuesta del resultado de la configuración en el dispositivo
    setConfigId: (configId: number) => void,
    updateNumZona: (newNumber: number) => void,
    updateZonas: (newZonas: zonaType[]) => void,
    updateZona: (newZona: zonaType) => void
}

export const useZonasStore = create<zonasState>((set) => {
    return {
        zonas: [
            { numZona: 0, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 2309737967, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 1, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 2309737967, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 2, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 3, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 4, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 5, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 6, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
            { numZona: 7, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: 'Sala', descripcionLarga: 'Sala' },
        ],
        numZona: 0,
        configSentFlag: false,
        configId: 0,
        configResp: 0,
        setConfigId: (configId: number) => set({configId: configId}),
        updateNumZona: (newNumber: number) => set({numZona: newNumber}),
        updateZonas: (newZonas: zonaType[]) => set({ zonas: newZonas }),
        updateZona: (newZona: zonaType) => set((state) => ({    //En "state" se tiene acceso a todo el store :)
            zonas: state.zonas.map((zona) => (
                zona.numZona === newZona.numZona ? newZona : zona
            ))
        }))
    }
})